import RetailAccountManager from '../retailAccounts/RetailAccountManager';

const MyPortfolios = () => (
  <div className="w-full max-w-[960px]">
    <RetailAccountManager variant="profile" />
  </div>
);

export default MyPortfolios;
